export const ButtonPressR = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.583 4C21.5745 4 24 6.42546 24 9.41699V18.583C24 21.5745 21.5745 24 18.583 24H9.41699C6.42546 24 4 21.5745 4 18.583V9.41699C4 6.42546 6.42546 4 9.41699 4H18.583ZM11 10.3301V17H12.7305V14.6504H13.8896L15.2695 17H17.2891L15.6797 14.2998C16.1063 14.1532 16.4396 13.9133 16.6797 13.5801C16.933 13.2334 17.0596 12.826 17.0596 12.3574C17.0596 11.7041 16.843 11.1702 16.4102 10.7559C15.9902 10.4714 15.4395 10.3301 14.7598 10.3301H11ZM12.7305 11.7402H14.6797C14.9997 11.7402 15.2463 11.8202 15.4199 11.9805C15.5932 12.1538 15.6797 12.377 15.6797 12.6504C15.6797 12.9169 15.5932 13.1338 15.4199 13.3008C15.2466 13.4674 15 13.5508 14.6797 13.5508H12.7305V11.7402Z"
        fill="#E3E5FA"
      />
    </svg>
  );
};
